/*window.addEventListener("globoFilterRenderCompleted", function(e) {
  var shopifyAjaxCartAddURL = '/cart/add.js';
  var shopifyAjaxCartURL = '/cart.js';
  $(".spf-product__form .spf-product__form-btn-addtocart").click(function() {
    var self = this;
    var id = $(self).closest('.spf-product__form').find('.spf-product__variants option:selected').val();
    console.log(id);
    //$(self).addClass("disabled").attr("disabled", true);
    $(self).html('<span>Adding...</span>');
    jQuery.ajax({
      type: 'POST',
      url: shopifyAjaxCartAddURL,
      dataType: 'json',
      data: 'id=' + id + '&quantity=1',
      error: function(data) {
        alert(data.responseJSON.description);
        $(self).removeClass("disabled").removeAttr("disabled");
        $(self).html('<i class="fa fa-shopping-bag" aria-hidden="true"></i><span>Add To Cart</span>');
      },
      success: function(data) {
        $('body').trigger('added.ajaxProduct');
        $(self).html('<span>Thank you!</span>');
        window.upcartOpenCart();
        $.ajax({
          method: "GET",
          url: '/cart.js',
          dataType: 'json',
          success: function(cart) {
            $(".cart-count-bubble").html('<span aria-hidden="true">' + cart.item_count + '</span><span class="visually-hidden">' + cart.item_count + ' items</span>');
            setTimeout(function() {
              // $(self).removeClass("disabled").removeAttr("disabled");
              $(self).html('<i class="fa fa-shopping-bag" aria-hidden="true"></i><span>Add To Cart</span>');
            }, 1800);
          }
        });
      }
    });
    return false;
  });
});*/

/*window.addEventListener("globoFilterRenderCompleted", function(e) {
  $(".spf-product__form").each(function() {
    var productForm = this;

    productForm.addEventListener('submit', function(evt) {
      evt.preventDefault(); // Prevenir comportamiento por defecto

      var submitButton = productForm.querySelector('.spf-product__form-btn-addtocart');
      var selectedVariantId = productForm.querySelector('[name=id]').value;

      // Verificar si el botón está deshabilitado
      if (submitButton.getAttribute('aria-disabled') === 'true') {
        return;
      }

      // Manejo de la notificación de error (si tienes un método para manejar errores)
      // this.handleErrorMessage();

      submitButton.setAttribute('aria-disabled', true);
      submitButton.classList.add('loading');
      var loadingOverlay = productForm.querySelector('.loading-overlay__spinner');
      if (loadingOverlay) loadingOverlay.classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(productForm);
      const cartNotification = document.querySelector('cart-notification'); // Verifica que esto está presente
      formData.append('sections', cartNotification.getSectionsToRender().map((section) => section.id));
      formData.append('sections_url', window.location.pathname);
      config.body = formData;
      debugger;

      // En tu función actual cuando se añade al carrito
      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            // Manejar el mensaje de error
            console.error(response.description);
            return;
          }

          // Si se añade correctamente, renderizamos el cart-notification y evitamos el open cart drawer
          cartNotification.renderContents(response);

          // Aquí puedes prevenir que UpCart abra el cart drawer
          // Suponiendo que UpCart utiliza algún tipo de evento para abrir el drawer, puedes cancelar eso:
          // Ejemplo: Si hay un evento que se llama, detén la propagación
          //document.body.dispatchEvent(new Event('stop:drawer:open'));

        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          submitButton.classList.remove('loading');
          submitButton.removeAttribute('aria-disabled');
          if (loadingOverlay) loadingOverlay.classList.add('hidden');
        });
    });
  });
});*/

window.addEventListener("globoFilterRenderCompleted", function(e) {
  var shopifyAjaxCartAddURL = '/cart/add.js';
  
  $(".spf-product__form .spf-product__form-btn-addtocart").click(function() {
    var self = this;
    var form = $(self).closest('.spf-product__form');
    var id = form.find('.spf-product__variants option:selected').val();

    console.log(id);
    $(self).html('<span>Adding...</span>');
    
    const cartNotification = document.querySelector('cart-notification'); // Verifica que esto está presente
    if (!cartNotification) {
      console.error("Cart notification element not found.");
      return false;
    }

    var formData = new FormData();
    formData.append('id', id);
    formData.append('quantity', 1);
    formData.append('sections', cartNotification.getSectionsToRender().map((section) => section.id));
    formData.append('sections_url', window.location.pathname);

    fetch(shopifyAjaxCartAddURL, {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
      body: formData
    })
    .then(response => response.json())
    .then(data => {
      if (data.status) {
        alert(data.description);
        $(self).html('<i class="fa fa-shopping-bag" aria-hidden="true"></i><span>Add To Cart</span>');
        return;
      }

      // Renderizar el contenido de la notificación sin abrir el cart drawer
      cartNotification.renderContents(data);

      // Actualizar contador del carrito
      $.ajax({
        method: "GET",
        url: '/cart.js',
        dataType: 'json',
        success: function(cart) {
          $(".cart-count-bubble").html('<span aria-hidden="true">' + cart.item_count + '</span><span class="visually-hidden">' + cart.item_count + ' items</span>');
          setTimeout(function() {
            $(self).html('<i class="fa fa-shopping-bag" aria-hidden="true"></i><span>Add To Cart</span>');
          }, 1800);
        }
      });
    })
    .catch(error => console.error('Error adding to cart:', error));

    return false;
  });
});